import { useSyncExternalStore } from "react";

import type { ImpersonationSession } from "../_libs/protocol";
import {
  getImpersonationSession,
  subscribeImpersonationSession,
} from "./impersonation-frame-session";

function getServerSnapshot(): ImpersonationSession | null {
  return null;
}

/**
 * The impersonation session this document runs under, or `null` when it is an
 * ordinary, first-party page. Surfaces read it to adapt — hide "Sign out" in
 * favour of "Exit impersonation", skip analytics and support-chat identify,
 * check feature gates for `target.userId` (the user the actor token was minted
 * for) — never to authorize: the platform decides whom requests run as from the
 * token.
 */
export function useImpersonationSession(): ImpersonationSession | null {
  return useSyncExternalStore(
    subscribeImpersonationSession,
    getImpersonationSession,
    getServerSnapshot,
  );
}
